'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _voucher = require('redux/modules/voucher');

var vouchersAction = _interopRequireWildcard(_voucher);

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VoucherMobile = (_dec = (0, _reactRedux.connect)(null, (0, _extends3.default)({}, vouchersAction)), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(VoucherMobile, _Component);

  function VoucherMobile() {
    (0, _classCallCheck3.default)(this, VoucherMobile);
    return (0, _possibleConstructorReturn3.default)(this, (VoucherMobile.__proto__ || (0, _getPrototypeOf2.default)(VoucherMobile)).apply(this, arguments));
  }

  (0, _createClass3.default)(VoucherMobile, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.getByUser();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { display: 'block', width: '100%', height: '100%' } },
        _react2.default.createElement(_components.VoucherMobile, null)
      );
    }
  }]);
  return VoucherMobile;
}(_react.Component), _class2.propTypes = {
  getByUser: _react.PropTypes.func,
  vouchers: _react.PropTypes.array
}, _temp)) || _class);
exports.default = VoucherMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Mobile/Voucher/VoucherMobile.js
// module id = 1680
// module chunks = 0